import React from "react";
import "./index.css"
import{BrowserRouter,Route,Routes} from 'react-router-dom';
import Register from "./pages/Register";
import Chat from "./pages/Chat";
import Login from "./pages/Login";
import SetAvtar from "./pages/SetAvatar";
import Footer from "./pages/Footer";
import About from "./pages/About";
import Developer from "./pages/Developer";
import Policy from "./pages/Policy";
import Profile from "./pages/Profile";
function App() {
  return (
  <>
<BrowserRouter>
<Routes>
<Route path="/register" element={<Register/>}/>
<Route path="/login" element={<Login/>}/>
<Route path="/setAvatar" element={<SetAvtar/>}/>
<Route path="/" element={<Chat/>}/>
<Route path="/about" element={<About/>}/>
<Route path="/policy" element={<Policy/>}/>
<Route path="/developer" element={<Developer/>}/>
<Route path="/profile" element={<Profile/>}/>
</Routes>
<Footer/>
</BrowserRouter>
</>
  );
}

export default App;
